import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faTabletScreenButton  } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import useApiFetch from '../../ApiFetch';


export default function EventKiosk(props) {
    const { eventData } = props;
    const apiFetch = useApiFetch();

    const [kioskUrl, setKioskUrl] = useState(null);
    const [copied, setCopied] = useState(false);

    const [modal, setModal] = useState(false);

    const modalToggle = () => {
        if (!modal) {
            getData();
        }
        setModal(!modal);
        setCopied(false);
    };

    useEffect(() => {
        //setLoading(true);
    }, []);

    const getData = async () => {
        await apiFetch.get('/api/event/' + encodeURIComponent(eventData.id) + '/kioskurl')
            .then(resp => {
                setKioskUrl(resp.data);
            });
    };
    const copyTextToClipboard = async (text) => {
        if ('clipboard' in navigator) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    setCopied(true);
                })
                .catch(err => {
                    console.error('Failed to copy!', err);
                });
        } else {
            return document.execCommand('copy', true, text);
        }
    };
    return (
        <>
            <FontAwesomeIcon icon={faTabletScreenButton} title="Kiosk Mode Link" className="text-primary lh-1 px-1" size="lg" style={{ cursor: 'pointer' }} onClick={modalToggle} />
            <Modal isOpen={modal} toggle={modalToggle} size="md" fade={true}>
                <ModalHeader toggle={modalToggle}>
                    <FontAwesomeIcon icon={faTabletScreenButton} className="pe-2" />Event Kiosk
                </ModalHeader>
                <ModalBody>
                    {/*{JSON.stringify(registrations)}*/}
                    <div className="text-center py-3">
                        {kioskUrl &&
                            <img className="d-block mx-auto img-fluid" src={`https://api.qrserver.com/v1/create-qr-code/?size=400x400&margin=10&data=${kioskUrl}`} alt="" />
                        }
                    </div>

                    <div className="input-group my-2">
                        <input type="text" className="form-control" value={kioskUrl ?? ''} readOnly onFocus={(e) => e.target.select()} />
                        <button className="btn btn-primary" type="button" title="Copy to Clipboard" onClick={() => copyTextToClipboard(kioskUrl)}>
                            <FontAwesomeIcon icon={faClipboard} />
                        </button>
                    </div>
                    {copied &&
                        <div className="text-secondary-emphasis text-center">
                            Link Copied!
                        </div>
                    }
                </ModalBody>
            </Modal>
        </>
    );
};
